/**
 * AddCouponCtrl controller
 */

import { getRandomString } from 'app/helpers/string'

/**
 * AddCouponCtrl controller
 *
 * @class AddReminderCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddCouponCtrl
 */
/* @ngInject */
export default function AddCouponCtrl ($uibModalInstance, Coupon, coupon, pckg) {
  var vm = this

  /**
   * Announcement
   *
   * @memberof mwApp/packages.controller:AddCouponCtrl
   * @type {models.Coupon}
   */
  vm.coupon = coupon

  /**
   * isNew flag
   *
   * @memberof mwApp/packages.controller:AddCouponCtrl
   * @type {Boolean}
   */
  vm.isNew = coupon._isNew()

  // load past discount extra
  Coupon.loadExtra({ networkId: pckg.id })
    .to(vm)
    .then((data) => {
      if (!vm.coupon.currencyId) {
        vm.coupon.currencyId = data.currencies.length ? data.currencies[0].id : 0 // set default value
      }
    })

  /**
   * Create or edit coupon, and close modal window afterwards
   *
   * @memberof mwApp/packages.controller:AddCouponCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    coupon._save({ networkId: pckg.id })
      .then(() => {
        coupon._update()
          .then(() => {
            $uibModalInstance.close(coupon)
            vm.unsetDisable()
          })
      })
      .finally(vm.unsetDisable)
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/packages.controller:AddCouponCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }

  /**
   * "From" datepicker settings
   *
   * @memberof mwApp/packages.controller:AddCouponCtrl
   */
  vm.dpCfgFrom = {
    format: 'dd.MM.yyyy',
    minDate: new Date(),
    changeHandler: function () {
      adjustDefaultDisplayMode()
    }
  }

  /**
   * "To" datepicker settings
   *
   * @memberof mwApp/packages.controller:AddCouponCtrl
   */
  vm.dpCfgTo = {
    format: 'dd.MM.yyyy',
    minDate: new Date(),
    changeHandler: function () {
      adjustDefaultDisplayMode()
    }
  }

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/packages.controller:AddCouponCtrl
   */
  vm.openFrom = function () {
    vm.dpCfgFrom.opened = true
  }

  /**
   * Function to get random code
   *
   * @memberof mwApp/packages.controller:AddCouponCtrl
   */
  vm.getRandomCode = function () {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    const min = 12
    const max = 12
    const str = getRandomString(chars, min, max)

    vm.coupon.couponCode = str.substring(0, 4) + '-' + str.substring(5, 9) + '-' + str.substring(10)
  }

  /**
   * Handle open "to" datepicker
   *
   * @memberof mwApp/packages.controller:AddCouponCtrl
   */
  vm.openTo = function () {
    vm.dpCfgTo.opened = true
  }

  function adjustDefaultDisplayMode () {
    if (vm.coupon.$fromDate < new Date()) {
      vm.coupon.$fromDate = new Date()
    }
    vm.dpCfgTo.minDate = vm.coupon.$fromDate
    vm.dpCfgFrom.minDate = vm.coupon.$fromDate

    if (vm.coupon.$fromDate > vm.coupon.$toDate) {
      vm.coupon.$toDate = vm.coupon.$fromDate
    }
  }
}
